/* EYESHELLS stability ownership v1458
   =========================================================
   EYESHELLS: Split engo-scripts.js -> engo-sections.js
   - Home/Page section sliders (services/testimonials/collections/lookbook/etc.)
   - Loaded only where these sections can appear
   ========================================================= */

(function($){
  $(function(){
    "use strict";

    if (window.__esEngoSectionsRuntimeBooted) return;
    window.__esEngoSectionsRuntimeBooted = true;

    var $doc = $(document);
    var $win = $(window);

    function canSlick(){
      return !!($.fn && $.fn.slick);
    }

    function getScope(scope){
      return scope && scope.jquery ? scope : $(scope || document);
    }

    
    function testimonialV1StopObserver(slider) {
      if (!slider || typeof slider.__esTestimonialV1ObserverStop !== 'function') return;
      try { slider.__esTestimonialV1ObserverStop(); } catch (_observerStopError) {}
      slider.__esTestimonialV1ObserverStop = null;
    }

    function testimonialV1InitSlider(slider) {
      if (!slider) return false;
      var $slider = $(slider);
      if ($slider.hasClass('slick-initialized')) {
        testimonialV1StopObserver(slider);
        return true;
      }
      if (slider.__esTestimonialV1Initializing) return false;

      slider.__esTestimonialV1Initializing = true;
      try {
        $slider.slick({
          autoplay: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          prevArrow: '<button class="testimonial-arrow arrow-prev"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow: '<button class="testimonial-arrow arrow-next"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      } catch (error) {
        slider.__esTestimonialV1Initializing = false;
        try { if (typeof window.ESDebug === 'function') window.ESDebug('section-init:.js-testimonial-v1', error); }
        catch (_debugError) {}
        return false;
      }

      slider.__esTestimonialV1Initializing = false;
      slider.setAttribute('data-es-deferred-ready', 'true');
      testimonialV1StopObserver(slider);
      return true;
    }

    function testimonialV1Observe(slider) {
      if (!slider || slider.__esTestimonialV1ObserverStop || $(slider).hasClass('slick-initialized')) return;

      var activate = function(entry) {
        if (entry && !entry.isIntersecting && entry.intersectionRatio <= 0) return;
        if (!testimonialV1InitSlider(slider)) {
          window.setTimeout(function(){ testimonialV1InitSlider(slider); }, 120);
        }
      };
      var options = { rootMargin: '700px 0px', threshold: 0.01 };

      if (window.ES && window.ES.observe && typeof window.ES.observe.intersection === 'function') {
        slider.__esTestimonialV1ObserverStop = window.ES.observe.intersection(slider, activate, options);
        return;
      }

      if (window.IntersectionObserver) {
        var observer = new window.IntersectionObserver(function(entries) {
          for (var i = 0; i < entries.length; i += 1) activate(entries[i]);
        }, options);
        observer.observe(slider);
        slider.__esTestimonialV1ObserverStop = function(){ observer.disconnect(); };
        return;
      }

      testimonialV1InitSlider(slider);
    }

    function testimonialV1(scope, forceInit) {
      var $scope = getScope(scope);
      var $sliders = $scope.is('.js-testimonial-v1')
        ? $scope
        : $scope.find('.js-testimonial-v1');

      $sliders.each(function(){
        if ($(this).hasClass('slick-initialized')) {
          testimonialV1StopObserver(this);
          return;
        }

        var deferred = this.getAttribute('data-es-deferred-carousel') === 'testimonial-v1';
        if (!deferred || forceInit || (window.Shopify && window.Shopify.designMode)) {
          testimonialV1InitSlider(this);
        } else {
          testimonialV1Observe(this);
        }
      });
    }

    function testimonialV1RearmObservers(scope) {
      var $scope = getScope(scope);
      var $sliders = $scope.is('[data-es-deferred-carousel="testimonial-v1"]')
        ? $scope
        : $scope.find('[data-es-deferred-carousel="testimonial-v1"]');
      $sliders.each(function(){
        if (!$(this).hasClass('slick-initialized')) testimonialV1StopObserver(this);
      });
    }
    
    function testimonialV2() {
        $('.js-testimonial-v2-slide').not('.slick-initialized').slick({
          autoplay: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: true,
          prevArrow: '<button class="testimonial-arrow arrow-prev"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow: '<button class="testimonial-arrow arrow-next"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    
    function servicev1(){
        $('.slickjs-services-v1').not('.slick-initialized').slick({
          dots: false,
          arrows:false,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 757,
              settings: {
                slidesToShow: 1,
                arrows:true,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                arrows:true,
              }
            }
          ]
        });
    
      }
    
    function servicev2(){
        $('.js-services-v2').not('.slick-initialized').slick({
          dots: false,
          arrows: false,
          infinite: false,
          speed: 300,
          autoplay:true,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    
    function brandv1() {
        $('.jsbrand_list_v1').not('.slick-initialized').slick({
          dots: false,
          arrows:false,
          speed: 300,
          slidesToShow: 5,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });
      }
    
    function slidehome1(){
          var $slider = $('.js-slideshow-v1');
          if(!$slider.length){
            // Fallback for older markup
            $slider = $('.slick-side-h1');
          }
          if(!$slider.length) return;
    
          // Avoid double init
          if ($slider.hasClass('slick-initialized')) {
            return;
          }
    
          
    var autoplay = String($slider.data('autoplay')) === 'true';
    var autoplaySpeed = parseInt($slider.data('autoplay-speed'), 10);
    if (!autoplaySpeed || autoplaySpeed < 500) autoplaySpeed = 4500;
    var pauseOnHover = String($slider.data('pause-on-hover')) !== 'false';
    $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: autoplay,
            autoplaySpeed: autoplaySpeed,
            pauseOnHover: pauseOnHover,
            pauseOnFocus: true,
            dots: false,
            arrows: true,
            fade : true,
            speed: 420,
            adaptiveHeight: false,
            
            prevArrow:'<button type="button" class="prev-slide" aria-label="Previous slide"><i class="fa-solid fa-angle-left"></i></button>',
            nextArrow:'<button type="button" class="next-slide" aria-label="Next slide"><i class="fa-solid fa-angle-right"></i></button>',
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  dots: true,
                  arrows: false
                }
              }
            ]
          });
        }
    
    function slidehome2(){
        $('.slick-side-h2').not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3500,
          dots: false,
          arrows: true,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          fade: true, 
          responsive: [
    
            {
              breakpoint: 1200,
              settings: {
                infinite: true,
                dots: false ,
                arrows: true
              }
            },
            {
              breakpoint: 1024,
              settings: {
                dots: false ,
                arrows: true
              }
            },
            {
              breakpoint:900,
              settings: {
                dots: true ,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3500
              }
            }
          ]
        });
      }
    
    function slidehome3(){
        $('.slick-side-h3').not('.slick-initialized').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3500,
          infinite: true,
          dots: false,
          arrows: true,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left" aria-hidden="true"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right" aria-hidden="true"></i></button>',
          fade: false, 
          responsive: [
    
            {
              breakpoint: 1200,
              settings: {
                infinite: true,
                dots: false ,
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1024,
              settings: {
                dots: false ,
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                dots: false ,
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 600,
              settings: {
                dots: false ,
                arrows: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    
    function slidehome4(){
        $('.js-slideshow-v4').not('.slick-initialized').slick({
          dots: false,
          fade:true,
          arrows: true,
          speed: 300,
          autoplay: false,
          adaptiveHeight: true,
          prevArrow: '<button type="button" class="slideshow-arrow slick-slide-prev fa-solid fa-angle-left"></button>',
          nextArrow: '<button type="button" class="slideshow-arrow slick-slide-next fa-solid fa-angle-right"></button>',
          asNavFor: '.js-slideshow-thumb'
        });
        $('.js-slideshow-thumb').not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,  
          fade:true,
          speed: 1000,
          asNavFor: '.js-slideshow-v4',
          dots: false,
          arrows: false,
          focusOnSelect: true
        });
    
        $('.js-slideshow-v4 .slider-info').eq(0).addClass('active')
        $('.js-slideshow-v4 .slider-img img').eq(0).addClass('active')
        $('.js-slideshow-thumb .banner-item img').eq(0).addClass('active')
        $('.js-slideshow-v4').off('beforeChange.esSectionsV4').on('beforeChange.esSectionsV4', function (event, slick, currentSlide, nextSlide) {
          var mySlideNumber = nextSlide;
          var prev = currentSlide;
          $('.js-slideshow-v4 .slider-info').eq(mySlideNumber).addClass('active');
          $('.js-slideshow-v4 .slider-img img').eq(mySlideNumber).addClass('active');
          $('.js-slideshow-thumb .banner-item img').eq(mySlideNumber).addClass('active');
          $('.js-slideshow-v4 .slider-info').eq(prev).removeClass('active');
          $('.js-slideshow-v4 .slider-img img').eq(prev).removeClass('active');
          $('.js-slideshow-thumb .banner-item img').eq(prev).removeClass('active');
        });
      }
    
    function slidehome5(){
        $('.slick-side-h5').not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3500,
          dots: true,
          arrows: true,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left" aria-hidden="true"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right" aria-hidden="true"></i></button>',
          fade: true, 
          responsive: [
    
            {
              breakpoint: 1200,
              settings: {
                infinite: true,
                dots: true ,
                arrows: false
              }
            },
            {
              breakpoint: 1024,
              settings: {
                dots: true ,
                arrows: false
              }
            },
            {
              breakpoint:600,
              settings: {
                dots: true ,
                arrows: false,
                autoplay: true,
              }
            }
          ]
        });
      }
    
    function Collectionv1() {
        $('.js-collection-v1').not('.slick-initialized').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          autoplay: false,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrow: false,
                dots: false
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: false
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: false
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                autoplay: true
              }
            }
          ]
        });
      }
    
    function Collectionv2() {
        $('.js-collection-v2').not('.slick-initialized').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          autoplay: false,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrow: false,
                dots: true
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                dots: true
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: true
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                autoplay: true
              }
            }
          ]
        });
      }
    
    function Collectionv3() {
        $('.js-collection-v3').not('.slick-initialized').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          autoplay: false,
          centerMode: true,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    
    function Blogv1(){
        $('.js-blog-v1').not('.slick-initialized').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
          arrows: false,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrow: false,
                dots: false
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                dots: false
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false
              }
            }
          ]
        });
      }
    
    function Blogv2(){
        $('.js-blog-v2').not('.slick-initialized').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
          arrows: true,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false
              }
            }
          ]
        });
      }
    
    function productV1StopObserver(slider) {
      if (!slider || typeof slider.__esProductV1ObserverStop !== 'function') return;
      try { slider.__esProductV1ObserverStop(); } catch (_observerStopError) {}
      slider.__esProductV1ObserverStop = null;
    }

    function productV1InitSlider(slider) {
      if (!slider) return false;
      var $slider = $(slider);
      if ($slider.hasClass('slick-initialized')) {
        productV1StopObserver(slider);
        return true;
      }
      if (slider.__esProductV1Initializing) return false;

      slider.__esProductV1Initializing = true;
      try {
        $slider.slick({
          slidesToShow: 4,
          slidesToScroll: 2,
          infinite: false,
          speed: 900,
          autoplay: false,
          autoplaySpeed: 3500,
          dots: true,
          arrows: false,
          prevArrow:'<button type="button" class="prev-slide slick-arrow"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide slick-arrow"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint:920,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint:768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                swipeToSlide: false,
                draggable: false,
                swipe: false,
                touchMove: false
              }
            }
          ]
        });
      } catch (error) {
        slider.__esProductV1Initializing = false;
        try { if (typeof window.ESDebug === 'function') window.ESDebug('section-init:.js_section_product', error); }
        catch (_debugError) {}
        return false;
      }

      slider.__esProductV1Initializing = false;
      slider.setAttribute('data-es-deferred-ready', 'true');
      productV1StopObserver(slider);
      return true;
    }

    function productV1Observe(slider) {
      if (!slider || slider.__esProductV1ObserverStop || $(slider).hasClass('slick-initialized')) return;

      var activate = function(entry) {
        if (entry && !entry.isIntersecting && entry.intersectionRatio <= 0) return;
        if (!productV1InitSlider(slider)) {
          window.setTimeout(function(){ productV1InitSlider(slider); }, 120);
        }
      };
      var options = { rootMargin: '700px 0px', threshold: 0.01 };

      if (window.ES && window.ES.observe && typeof window.ES.observe.intersection === 'function') {
        slider.__esProductV1ObserverStop = window.ES.observe.intersection(slider, activate, options);
        return;
      }

      if (window.IntersectionObserver) {
        var observer = new window.IntersectionObserver(function(entries) {
          for (var i = 0; i < entries.length; i += 1) activate(entries[i]);
        }, options);
        observer.observe(slider);
        slider.__esProductV1ObserverStop = function(){ observer.disconnect(); };
        return;
      }

      productV1InitSlider(slider);
    }

    function product_v1(scope, forceInit) {
      var $scope = getScope(scope);
      var $sliders = $scope.is('.js_section_product')
        ? $scope
        : $scope.find('.js_section_product');

      $sliders.each(function(){
        if ($(this).hasClass('slick-initialized')) {
          productV1StopObserver(this);
          return;
        }

        var deferred = this.getAttribute('data-es-deferred-carousel') === 'product-v1';
        if (!deferred || forceInit || (window.Shopify && window.Shopify.designMode)) {
          productV1InitSlider(this);
        } else {
          productV1Observe(this);
        }
      });
    }
    
    function productV5() {
        $('.js_product_v5').not('.slick-initialized').slick({
          dots: false,
          arrows: false,
          infinite: true,
          speed: 300,
          autoplay: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve"> <g> <g> <path d="M143.492,221.863L336.226,29.129c6.663-6.664,6.663-17.468,0-24.132c-6.665-6.662-17.468-6.662-24.132,0l-204.8,204.8 c-6.662,6.664-6.662,17.468,0,24.132l204.8,204.8c6.78,6.548,17.584,6.36,24.132-0.42c6.387-6.614,6.387-17.099,0-23.712 L143.492,221.863z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
          nextArrow:'<button type="button" class="next-slide"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <g> <path d="M390.965,241.681l-242.001-236c-7.907-7.711-20.57-7.553-28.282,0.355c-7.712,7.908-7.553,20.57,0.355,28.282L348.353,256 L121.037,477.681c-7.908,7.712-8.067,20.374-0.355,28.282c7.713,7.91,20.375,8.065,28.281,0.355l242.001-236 C394.823,266.555,397,261.391,397,256S394.823,245.445,390.965,241.681z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>', 
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
    
      }
    
    function productV6(){
        $('.js_product_v6').not('.slick-initialized').slick({
          dots: true,
          arrows:false,
          infinite: false,
          speed: 300,
          autoplay:true,
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve"> <g> <g> <path d="M143.492,221.863L336.226,29.129c6.663-6.664,6.663-17.468,0-24.132c-6.665-6.662-17.468-6.662-24.132,0l-204.8,204.8 c-6.662,6.664-6.662,17.468,0,24.132l204.8,204.8c6.78,6.548,17.584,6.36,24.132-0.42c6.387-6.614,6.387-17.099,0-23.712 L143.492,221.863z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
          nextArrow:'<button type="button" class="next-slide"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <g> <path d="M390.965,241.681l-242.001-236c-7.907-7.711-20.57-7.553-28.282,0.355c-7.712,7.908-7.553,20.57,0.355,28.282L348.353,256 L121.037,477.681c-7.908,7.712-8.067,20.374-0.355,28.282c7.713,7.91,20.375,8.065,28.281,0.355l242.001-236 C394.823,266.555,397,261.391,397,256S394.823,245.445,390.965,241.681z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>', 
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
    
      }
    
    function jsbannerv1(){
        $('.js_banner_v1').not('.slick-initialized').slick({
          dots: false,
          arrows: false,
          infinite: true,
          speed: 600,
          autoplay:false,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    
    function flashSaleStopObserver(slider) {
      if (!slider || typeof slider.__esFlashSaleObserverStop !== 'function') return;
      try { slider.__esFlashSaleObserverStop(); } catch (_observerStopError) {}
      slider.__esFlashSaleObserverStop = null;
    }

    function flashSaleInitSlider(slider) {
      if (!slider) return false;
      var $slider = $(slider);
      if ($slider.hasClass('slick-initialized')) {
        flashSaleStopObserver(slider);
        return true;
      }
      if (slider.__esFlashSaleInitializing) return false;

      slider.__esFlashSaleInitializing = true;
      try {
        $slider.slick({
          arrows: false,
          infinite: true,
          dots: true ,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 3,
          autoplay: true,
          autoplaySpeed: 2000,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left" aria-hidden="true"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right" aria-hidden="true"></i></button>', 
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                autoplay: false,
                swipeToSlide: false,
                draggable: false,
                swipe: false,
                touchMove: false
              }
            }
          ]
        });
      } catch (error) {
        slider.__esFlashSaleInitializing = false;
        try { if (typeof window.ESDebug === 'function') window.ESDebug('section-init:.slick_product_5', error); }
        catch (_debugError) {}
        return false;
      }

      slider.__esFlashSaleInitializing = false;
      slider.setAttribute('data-es-deferred-ready', 'true');
      flashSaleStopObserver(slider);
      return true;
    }

    function flashSaleObserve(slider) {
      if (!slider || slider.__esFlashSaleObserverStop || $(slider).hasClass('slick-initialized')) return;

      var activate = function(entry) {
        if (entry && !entry.isIntersecting && entry.intersectionRatio <= 0) return;
        if (!flashSaleInitSlider(slider)) {
          window.setTimeout(function(){ flashSaleInitSlider(slider); }, 120);
        }
      };
      var options = { rootMargin: '700px 0px', threshold: 0.01 };

      if (window.ES && window.ES.observe && typeof window.ES.observe.intersection === 'function') {
        slider.__esFlashSaleObserverStop = window.ES.observe.intersection(slider, activate, options);
        return;
      }

      if (window.IntersectionObserver) {
        var observer = new window.IntersectionObserver(function(entries) {
          for (var i = 0; i < entries.length; i += 1) activate(entries[i]);
        }, options);
        observer.observe(slider);
        slider.__esFlashSaleObserverStop = function(){ observer.disconnect(); };
        return;
      }

      flashSaleInitSlider(slider);
    }

    function js_product_flashsale(scope, forceInit) {
      var $scope = getScope(scope);
      var $sliders = $scope.is('.slick_product_5')
        ? $scope
        : $scope.find('.slick_product_5');

      $sliders.each(function(){
        if ($(this).hasClass('slick-initialized')) {
          flashSaleStopObserver(this);
          return;
        }

        var deferred = this.getAttribute('data-es-deferred-carousel') === 'flash-sale';
        if (!deferred || forceInit || (window.Shopify && window.Shopify.designMode)) {
          flashSaleInitSlider(this);
        } else {
          flashSaleObserve(this);
        }
      });
    }

    function flashSaleRearmObservers(scope) {
      var $scope = getScope(scope);
      var $sliders = $scope.is('[data-es-deferred-carousel="flash-sale"]')
        ? $scope
        : $scope.find('[data-es-deferred-carousel="flash-sale"]');
      $sliders.each(function(){
        if (!$(this).hasClass('slick-initialized')) flashSaleStopObserver(this);
      });
    }
    
    function jsslidelookbook(){
        $('.js_slide_lookbook').not('.slick-initialized').slick({
          dots: false,
          arrows:false,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 1,
          slidesToScroll: 1
        });
    
      }

    function runIf(sel, fn, scope){
      var $scope = getScope(scope);
      if ($scope.find(sel).length || (scope && $scope.is(sel))) {
        try { fn(); }
        catch(e) {
          try { if (typeof window.ESDebug === 'function') window.ESDebug('section-init:' + sel, e); }
          catch (_debugError) {}
        }
      }
    }

    function initAll(scope, options){
      if (!canSlick()) return;
      runIf('.js-testimonial-v1', function(){ testimonialV1(scope, !!(options && options.forceTestimonialV1)); }, scope);
      runIf('.js-testimonial-v2', testimonialV2, scope);
      runIf('.slickjs-services-v1', servicev1, scope);
      runIf('.js-services-v2', servicev2, scope);
      runIf('.jsbrand_list_v1', brandv1, scope);
      runIf('.js-slideshow-v1', slidehome1, scope);
      runIf('.slick-side-h2', slidehome2, scope);
      runIf('.slick-side-h3', slidehome3, scope);
      runIf('.js-slideshow-v4', slidehome4, scope);
      runIf('.slick-side-h5', slidehome5, scope);
      runIf('.js-collection-v1', Collectionv1, scope);
      runIf('.js-collection-v2', Collectionv2, scope);
      runIf('.js-collection-v3', Collectionv3, scope);
      runIf('.js-blog-v1', Blogv1, scope);
      runIf('.js-blog-v2', Blogv2, scope);
      runIf('.js_section_product', function(){ product_v1(scope, !!(options && options.forceProductV1)); }, scope);
      runIf('.js_product_v5', productV5, scope);
      runIf('.js_product_v6', productV6, scope);
      runIf('.js_banner_v1', jsbannerv1, scope);
      runIf('.slick_product_5', function(){ js_product_flashsale(scope, !!(options && options.forceFlashSale)); }, scope);
      runIf('.js_slide_lookbook', jsslidelookbook, scope);
    }

    initAll(document, {
      forceProductV1: !!(window.Shopify && window.Shopify.designMode),
      forceFlashSale: !!(window.Shopify && window.Shopify.designMode),
      forceTestimonialV1: !!(window.Shopify && window.Shopify.designMode)
    });

    $win.off('pageshow.esSections').on('pageshow.esSections', function(){
      flashSaleRearmObservers(document);
      testimonialV1RearmObservers(document);
      initAll(document, {
        forceProductV1: !!(window.Shopify && window.Shopify.designMode),
        forceFlashSale: !!(window.Shopify && window.Shopify.designMode),
        forceTestimonialV1: !!(window.Shopify && window.Shopify.designMode)
      });
    });

    $doc.off('shopify:section:load.esSections shopify:section:select.esSections shopify:section:unload.esSections')
      .on('shopify:section:load.esSections shopify:section:select.esSections', function(evt){
        initAll(evt.target || document, { forceProductV1: true, forceFlashSale: true, forceTestimonialV1: true });
      })
      .on('shopify:section:unload.esSections', function(evt){
        var $scope = getScope(evt.target || document);
        var $sliders = $scope.is('[data-es-deferred-carousel="product-v1"]')
          ? $scope
          : $scope.find('[data-es-deferred-carousel="product-v1"]');
        $sliders.each(function(){ productV1StopObserver(this); });

        var $flashSaleSliders = $scope.is('[data-es-deferred-carousel="flash-sale"]')
          ? $scope
          : $scope.find('[data-es-deferred-carousel="flash-sale"]');
        $flashSaleSliders.each(function(){ flashSaleStopObserver(this); });

        var $testimonialV1Sliders = $scope.is('[data-es-deferred-carousel="testimonial-v1"]')
          ? $scope
          : $scope.find('[data-es-deferred-carousel="testimonial-v1"]');
        $testimonialV1Sliders.each(function(){ testimonialV1StopObserver(this); });
      });
  });
})(window.jQuery);
